import Image from 'next/image'

export const MetaMaskLogo = () => (
  <img alt='MetaMask Logo' className='h-14' src='/images/metamask-developer-wordmark.svg' />
)

export const MetaMaskLogoVertical = () => (
  <img alt='MetaMask Logo' className='max-w-[80%]' src='/images/metamask-developer-wordmark-vertical.svg' />
)

export const MetaMaskDeveloperFox = () => (
  <Image alt='MetaMask icon' className='h-8 w-8' height='32' src='/svg/icons/MetaMask.svg' width='32' />
)
